export const AFFILIATE_METRICS_HEADERS = [
  {
    key: 'clientId',
    label: 'Affiliate name',
    type: 'dropdownCity',
  },
  {
    key: 'affiliateTotalInserts',
    label: 'Total inserts',
    type: 'number',
  },
  {
    key: 'affiliateTotalPacks',
    label: 'Total packs',
    type: 'default',
  },
  {
    key: 'affiliateInsertCost',
    label: 'Insert cost',
    type: 'currencySign',
  },
  {
    key: 'affiliateFreightCost',
    label: 'Freight cost',
    type: 'currencySign',
  },
  {
    key: 'affiliatePromofyFee',
    label: 'Promofy fee',
    type: 'currencySign',
  },
  {
    key: 'affiliatePrintingCost',
    label: 'Printing cost',
    type: 'currencySign',
  },
  {
    key: 'affiliateBonusBudget',
    label: 'Bonus budget',
    type: 'currencySign',
  },
  {
    key: 'totalCost',
    label: 'Total cost',
    type: 'currencySignTotal',
  },
  {
    key: 'delete',
    label: '',
    type: 'delete',
  },
]

export const INSERTS_PACK_SIZE = { DEFAULT: 500 }
